import { categories } from '@/mocks/categories';

function scrollToSection(id: string) {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

export default function Footer() {
  const guideCategories = categories.slice(0, 5);
  const moreCategories = categories.slice(5, 10);
  const otherCategories = categories.slice(10);

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 pb-2 border-b border-background-200/60">
              Quick Links
            </h4>
            <div className="flex flex-col gap-2.5">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
              >
                Sugargoo Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
              >
                Buy It Now
              </a>
              <button
                onClick={() => scrollToSection('home')}
                className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer text-left"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('guide')}
                className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer text-left"
              >
                Guides
              </button>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 pb-2 border-b border-background-200/60">
              Top Categories
            </h4>
            <div className="flex flex-col gap-2.5">
              {guideCategories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 pb-2 border-b border-background-200/60">
              More Categories
            </h4>
            <div className="flex flex-col gap-2.5">
              {moreCategories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 pb-2 border-b border-background-200/60">
              Resources
            </h4>
            <div className="flex flex-col gap-2.5">
              {otherCategories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-6">
          <div>
            <p className="text-2xl font-heading italic text-foreground-900 tracking-tight">
              Sugargoo Spreadsheet
            </p>
            <p className="text-xs text-foreground-500 mt-1">
              Your trusted resource for curated finds and community-vetted spreadsheets.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-4 text-xs text-foreground-500">
            <button
              onClick={() => scrollToSection('safety')}
              className="hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Disclaimer
            </button>
            <button
              onClick={() => scrollToSection('safety')}
              className="hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Safety Guide
            </button>
            <span>&copy; 2026 SugargooSpreadsheet.wtf</span>
          </div>
        </div>
      </div>
    </footer>
  );
}